import { render, staticRenderFns } from "./inviteAddPeer.vue?vue&type=template&id=1cc97f57&scoped=true&"
import script from "./inviteAddPeer.vue?vue&type=script&lang=js&"
export * from "./inviteAddPeer.vue?vue&type=script&lang=js&"
import style0 from "./inviteAddPeer.vue?vue&type=style&index=0&id=1cc97f57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc97f57",
  null
  
)

export default component.exports